// extracted by mini-css-extract-plugin
module.exports = {"title":"graphs_title__1pQYq","graph_wrapper":"graphs_graph_wrapper__3KkUD"};